module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "slider-section",
    style: ({
      width: (_vm.width + "px"),
      height: (_vm.height + "px")
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ready),
      expression: "ready"
    }],
    staticClass: "slider"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "item",
      class: {
        animating: _vm.isAnimating(index),
          active: index == _vm.activeIndex
      },
      style: ({
        transform: ("translateX(" + (_vm.calculatetranslate(index)) + "px)"),
        '-webkit-transform': ("translateX(" + (_vm.calculatetranslate(index)) + "px)"),
        '-moz-transform': ("translateX(" + (_vm.calculatetranslate(index)) + "px)"),
        '-o-transform': ("translateX(" + (_vm.calculatetranslate(index)) + "px)")
      }),
      on: {
        "click": function($event) {
          _vm.clickItem(item)
        }
      }
    }, [_c('figure', [_c('img', {
      attrs: {
        "src": item.image_url
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "focus-item"
  }, [_c('ul', _vm._l((_vm.items), function(item, index) {
    return _c('li', [_c('div', {
      class: {
        active: _vm.activeIndex == index
      }
    })])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c15f9ce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider.vue
// module id = 247
// module chunks = 1